var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"bordered-container",style:([_vm.containerStyle, _vm.sidebarStyles]),attrs:{"fluid":""}},[_c('v-col',{attrs:{"cols":"12"}},[_c('component-wrapper',{attrs:{"config":_vm.component}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }